import { render, staticRenderFns } from "./logo-affiliate-svg.vue?vue&type=template&id=3c5ea739"
import script from "./logo-affiliate-svg.vue?vue&type=script&lang=js"
export * from "./logo-affiliate-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports